import { Component, OnInit } from '@angular/core';
import { MessagePopService, MessagePopConstants, MessagePopConfig } from "./message-pop.service";

@Component({
  selector: 'app-message-pop',
  templateUrl: './message-pop.component.html',
  styleUrls: ['./message-pop.component.scss']
})
export class MessagePopComponent implements OnInit {

  subject: string = "";
  message: string = "";
  statusClass: string = MessagePopConstants.SUCCESS;
  showMessageFlag: boolean = false;

  constructor(private messagePopService: MessagePopService) {
    this.messagePopService.notifySubject.subscribe((data: any) => {
      this.notifyMessage(data);
    });
  }

  notifyMessage(messageConfig: MessagePopConfig) {
    this.subject = messageConfig.subject;
    this.message = messageConfig.message;
    this.statusClass = messageConfig.status;
    this.showMessageFlag = true;
    setTimeout(() => {
      this.showMessageFlag = false;
    }, messageConfig.timeDelay || 2000);
  }

  ngOnInit(): void {
  }

}
